import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { AuthorisationManager, Identity, Icon, Message } from 'wc-lib';
import { Service } from '../service';
import { MenuItem } from '../model/menu-item';
import { Favourite } from '../model/favourite';
import Clone from 'clone';
import { MenuItemComponent } from '../components/menu-item';
import { FavouriteMenu } from '../components/favourite-menu';
import { MobileFavouriteMenu } from '../components/mobile-favourite-menu';
import { MobileMenuItemComponent } from '../components/mobile-menu-item';
import { Links } from '../components/links';
import { mixin as Clickaway } from 'vue-clickaway';
import { EnvironmentBar } from './environment-bar';
import { PersistentNotification } from '../components/persistent-notification';
import Config from '../config';
import { config } from '../../wdio.conf';

require('../../node_modules/wc-lib/icons/right.svg');
require('../../node_modules/wc-lib/icons/left.svg');
require('../../icons/downp.svg');
require('../../icons/logout.svg');
require('../../icons/menu.svg');
require('../../icons/help.svg');
require('../../icons/search.svg');
require('../../icons/notification.svg');
require('../../icons/notificationactive.svg');
require('../../icons/favourite.svg');
require('../../icons/favourite-selected.svg');
require('../../icons/favourite-unselected.svg');
require('../../icons/password.svg');
require('../../icons/profile.svg');
require('../../icons/view.svg');
require('../../icons/is-favourite.svg');
require('../../icons/not-favourite.svg');
require('../../icons/home.svg');


@Component({
  template: require('./menu.html'),
  components: {
    'wc-icon': Icon,
    'menu-item': MenuItemComponent,
    'mobile-menu-item': MobileMenuItemComponent,
    'favourite-menu': FavouriteMenu,
    'mobile-favourite-menu': MobileFavouriteMenu,
    'links': Links,
    'environment-bar': EnvironmentBar,
    'persistent-notification': PersistentNotification,
  }
})
export class Menu extends mixins(Clickaway) {
  mainMenuItems: MenuItem[] = [];
  activeMenuItem: string = '';
  activeItem: MenuItem = null;
  title: string = '';
  showUserMenu: boolean = false;
  searchString: string = '';
  searchItems: MenuItem[] = [];
  participantId: string = '';
  participantName: string = '';
  menuClosed: boolean = false;
  favouritesClosed: boolean = true;
  environment: string = '';
  hideSetParticipant: boolean = false;
  hideChangePassword: boolean = false;
  changePasswordRedirectUrl: string = '';
  defaultHelpUrl: string = '';
  originalParticipantId: string = '';
  hasNewNotifications: boolean = false;

  async mounted() {
    let tokenString = localStorage.getItem('aemo-session');
    if (tokenString !== undefined && tokenString !== '') {
      let token = JSON.parse(tokenString);
      this.originalParticipantId = token.PrimaryParticipantId;
    }
    if (window.innerWidth < 768) {
      this.menuClosed = true;
    }
    
    this.participantId = AuthorisationManager.getParticipant();
    this.participantName = AuthorisationManager.getParticipantName();
    setInterval(() => {
      this.participantId = AuthorisationManager.getParticipant();
      this.participantName = AuthorisationManager.getParticipantName();
    }, 1000);
    this.environment = Config.environment;
    if (Config.hideSetParticipant) {
      this.hideSetParticipant = true;
    } else {
      let getParticipantsResponse = await Service.getParticipants();
      this.hideSetParticipant = getParticipantsResponse.data.participantList.length <= 1 || Config.hideSetParticipant;
    }
    this.hideChangePassword = Config.hideChangePassword;
    this.changePasswordRedirectUrl = Config.changePasswordRedirectUrl;
    this.title = Config.title;
    this.defaultHelpUrl = Config.helpUrl;
    let menuData = await Service.getMenuItems();
    this.mainMenuItems = menuData.data.menuItemList;
    this.activeItem = this.mainMenuItems[0];
    //this.activeItem = this.mainMenuItems[0];
    this.activeMenuItem = this.activeItem.menuItemText;
    this.$store.commit('app/setFavourites', (await Service.getFavourites()).favourites);
    
    //check for new notifications every 5 minutes
    this.checkHasNewNotifications();
    setInterval(async () => {
      this.checkHasNewNotifications();
    }, 60000 * 5);
  }

  async checkHasNewNotifications() {
    let lastReadDateTime: Date;
    if (localStorage.getItem('lastReadDateTime')) {
      lastReadDateTime = new Date(localStorage.getItem('lastReadDateTime'));
    } else {
      lastReadDateTime = new Date(2019, 0, 1);
    }
    let notifications = (await Service.getUnreadNotifications(lastReadDateTime)).notifications;
    if (notifications.length > 0) {
      //do something to show notifications in top left
      this.hasNewNotifications = true;
    } else {
      this.hasNewNotifications = false;
    }
  }

  flatten(item: MenuItem) {
    let result = [];
    if (item.linkUrl) {
      result.push(item);
    }
    for(let subItem of item.subMenuItemList) {
      result = result.concat(this.flatten(subItem));
    }
    return result;
  }

  @Watch('searchString')
  onSearchItems() {
    let searchItems = Clone(this.mainMenuItems);
    this.searchItems = searchItems.map(searchItem => this.filterMenuItem(searchItem)).filter(x => x);
    /*for(let searchItem of searchItems) { 
      this.searchItems = this.filterMenuItem(searchItem);
    }*/

  }

  containsSearchString(item: MenuItem) {
    let contains = false;
    if (item.menuItemText.toLowerCase().includes(this.searchString.toLowerCase())) {
      return true;
    } else {
      for(let subItem of item.subMenuItemList) {
        contains = this.containsSearchString(subItem);
        if (contains) {
          return true;
        }
      }
    }
    return contains;
  }

  get identity() {
    let identity = localStorage.getItem('aemo-session');
    if (identity) {
      return JSON.parse(identity);
    } else {
      return null;
    }
  }

  filterMenuItem(item: MenuItem) {
    if (item.menuItemText.toLowerCase().includes(this.searchString.toLowerCase())) {
      item.isActive = true;
      return item;
    } else {
      let subMenuList = [];
      for(let subItem of item.subMenuItemList) {
        let contains = this.containsSearchString(subItem);
        if (contains) {
          let filterItem = this.filterMenuItem(subItem);
          filterItem.isActive = true;
          subMenuList.push(filterItem);
        }
      }
      item.subMenuItemList = subMenuList;
      return item;
    }
  }
  
  toggleUserMenu() {
    if (this.showUserMenu === false) {
      if (window.innerWidth < 768) {
        this.menuClosed = true;
      }
    }
    this.showUserMenu = !this.showUserMenu;
  }

  hideUserMenu() {
    this.showUserMenu = false;
  }

  toggleMenu() {
    if (this.menuClosed) {
      if (window.innerWidth < 768) {
        this.showUserMenu = false;
      }
      this.menuClosed = false;
      this.favouritesClosed = true;
    } else {
      this.menuClosed = true;
    }
  }

  clickHome() {
    this.resetMenuItem();
    if (window.innerWidth < 768) {
      this.menuClosed = true;
    }
  }

  toggleFavourites() {
    if (this.favouritesClosed) {
      this.favouritesClosed = false;
      this.menuClosed = true;
    } else {
      this.favouritesClosed = true;
    }
  }

  toggleMobileFavourites() {
    this.favouritesClosed = !this.favouritesClosed;
  }
  
  signout() {
    Config.skipLogin = false;
    this.resetMenuItem();
    this.$router.push({ path: 'signin' });
  }

  get menuItemText() {
    return this.$store.getters['app/menuItemText'];
  }

  get menuItemId() {
    return this.$store.getters['app/menuItemId'];
  }

  get helpUrl() {
    let helpUrl = this.$store.getters['app/helpUrl'];
    if (helpUrl) {
      return helpUrl;
    } else {
      return this.defaultHelpUrl;
    }
  }

  readNotification() {
    this.hasNewNotifications = false;
    this.resetMenuItem();
  }

  resetMenuItem() {
    this.$store.commit('app/setCurrentMenuItem', { menuItemId: null, menuItemText: null, helpUrl: null });
  }

  get favourites() {
    return this.$store.getters['app/favourites'];
  }

  get itemFavourited() {
    return this.favourites.some(x => x.menuItemId == this.menuItemId);
  }

  async favouriteItem() {
    if (this.menuItemId) {
      let existingFavouriteItem = this.favourites.find(x => x.menuItemId === this.menuItemId);
      if (existingFavouriteItem) {
        //remove favourite item
        await Service.removeFavourite(this.menuItemId);
        const existingFavouriteItemIndex = this.favourites.indexOf(existingFavouriteItem);
        this.favourites.splice(existingFavouriteItemIndex, 1);

        Message.success(`Removed favourite [${this.menuItemText}]`);
      } else {
        //add favourite 
        await Service.addFavourite(this.menuItemId);
        this.$store.commit('app/setFavourites', (await Service.getFavourites()).favourites);
        Message.success(`Saved favourite [${this.menuItemText}]`);
      }
    }
  }

  goToSetParticipant() {
    this.toggleUserMenu();
    this.resetMenuItem();
  }
}





// WEBPACK FOOTER //
// src/views/menu.ts